"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildingGovIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var BuildingGovIcon16Light_1 = require("./BuildingGovIcon16Light");
var BuildingGovIcon16Regular_1 = require("./BuildingGovIcon16Regular");
var BuildingGovIcon16Solid_1 = require("./BuildingGovIcon16Solid");
var BuildingGovIcon20Light_1 = require("./BuildingGovIcon20Light");
var BuildingGovIcon20Regular_1 = require("./BuildingGovIcon20Regular");
var BuildingGovIcon20Solid_1 = require("./BuildingGovIcon20Solid");
var BuildingGovIcon24Regular_1 = require("./BuildingGovIcon24Regular");
var BuildingGovIcon24Solid_1 = require("./BuildingGovIcon24Solid");
var BuildingGovIcon32Regular_1 = require("./BuildingGovIcon32Regular");
var BuildingGovIcon64Regular_1 = require("./BuildingGovIcon64Regular");
var sizes = {
    16: {
        light: BuildingGovIcon16Light_1.BuildingGovIcon16Light,
        regular: BuildingGovIcon16Regular_1.BuildingGovIcon16Regular,
        solid: BuildingGovIcon16Solid_1.BuildingGovIcon16Solid,
    },
    20: {
        light: BuildingGovIcon20Light_1.BuildingGovIcon20Light,
        regular: BuildingGovIcon20Regular_1.BuildingGovIcon20Regular,
        solid: BuildingGovIcon20Solid_1.BuildingGovIcon20Solid,
    },
    24: {
        regular: BuildingGovIcon24Regular_1.BuildingGovIcon24Regular,
        solid: BuildingGovIcon24Solid_1.BuildingGovIcon24Solid,
    },
    32: {
        regular: BuildingGovIcon32Regular_1.BuildingGovIcon32Regular,
    },
    64: {
        regular: BuildingGovIcon64Regular_1.BuildingGovIcon64Regular,
    },
};
exports.BuildingGovIcon = forwardRef_1.forwardRef('BuildingGovIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
